import React from 'react';

const Filters = ({
  searchQuery,
  setSearchQuery,
  yearRange,
  setYearRange,
  regionFilter,
  setRegionFilter,
  onReset
}) => {
  return (
    <section id="galerie" className="bg-gradient-to-b from-[#F5F1E8] to-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-2">
            Colecția Completă de Hărți
          </h2>
          <p className="text-gray-600">Explorează arhiva noastră de hărți istorice</p>
        </div>

        {/* Filters Container */}
        <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 border border-gray-200">
          
          {/* Row 1: Search + Reset */}
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            {/* Search Input */}
            <div className="relative flex-grow">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-[#8B7355]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                type="text"
                className="block w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-lg bg-gray-50 placeholder-gray-400 focus:outline-none focus:border-[#8B7355] focus:ring-2 focus:ring-[#8B7355]/20 transition-colors"
                placeholder="Caută după titlu, autor sau regiune..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Reset Button */}
            <button
              onClick={onReset}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition-colors border border-gray-300"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Resetează
            </button>
          </div>

          {/* Row 2: Year Range Slider - Full Width */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#8B7355] uppercase tracking-wider mb-2">
              Perioada: <span className="text-gray-700">{yearRange[0]} {yearRange[0] < 500 ? 'D.Hr.' : ''} - {yearRange[1]}</span>
            </label>
            <div className="flex items-center gap-4 px-2">
              <span className="text-sm font-medium text-gray-500 min-w-[60px]">150 D.Hr.</span>
              <input
                type="range"
                min="150"
                max="2026"
                step="10"
                value={yearRange[1]}
                onChange={(e) => setYearRange([yearRange[0], parseInt(e.target.value)])}
                className="year-slider w-full h-2 bg-gray-200 rounded-full cursor-pointer"
              />
              <span className="text-sm font-medium text-gray-500 min-w-[40px]">2026</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Filters;
